import { ColorEnum } from '@/constants/color'
import { DeliveryTime } from '@/features/orders/types/app'
import Typography from '@/features/ui/typography'
import { useIntervaledState } from '@/hooks/useIntervalState'
import { getCountdown } from '@/utils/getCountdown'
import { FC, useCallback } from 'react'
import { StyleSheet } from 'react-native'

interface CountdownWithDeliveryTypeCategoryProps {
    deliveryTime: DeliveryTime
}

const CountdownWithDeliveryTypeCategory: FC<CountdownWithDeliveryTypeCategoryProps> = ({
    deliveryTime,
}) => {
    const [countdown, isDelayed] = useIntervaledState(
        useCallback(() => getCountdown(deliveryTime), [deliveryTime]),
        60000
    )

    const color = !isDelayed ? ColorEnum.EMERALD_700 : ColorEnum.BRICK_500

    return (
        <Typography.Description
            size="large"
            font="bold"
            style={[styles.countdown, { color }]}
            numberOfLines={1}
        >
            {countdown}
        </Typography.Description>
    )
}

const styles = StyleSheet.create({
    countdown: {
        lineHeight: 21,
    },
})

export default CountdownWithDeliveryTypeCategory
